import React from 'react';
import HoldingsCard from '@/components/charts/HoldingsCard';
import IndustryDistribution from '@/components/charts/IndustryDistribution';
import Summary from '@/components/Summary';

// interface PositionAnalysisProps {
//   selected?: boolean;
//   onSelectChange?: (checked: boolean) => void;
// }

const PositionAnalysis: React.FC<any> = ({ selected = false, onSelectChange, totalData }) => {
  const productInfo = totalData?.product_info || [];
  const product1Data = productInfo[0] || {};
  const product2Data = productInfo[1] || {};
  // 招商新能源持仓数据
  const zhaoshangHoldings = [
    { name: '宁德时代', percentage: 8.2, color: '#5959EB' },
    { name: '比亚迪', percentage: 7.8, color: '#1269FF' },
    { name: '隆基绿能', percentage: 7.8, color: '#13C2C2' },
    { name: '阳光电源', percentage: 7.8, color: '#FA8C16' },
    { name: '通威股份', percentage: 7.8, color: '#EB2F96' }
  ];

  // 易方达消费持仓数据
  const yifangdaHoldings = [
    { name: '贵州茅台', percentage: 8.2, color: '#5959EB' },
    { name: '五粮液', percentage: 7.8, color: '#1269FF' },
    { name: '美团-W', percentage: 7.8, color: '#13C2C2' },
    { name: '腾讯控股', percentage: 7.8, color: '#FA8C16' },
    { name: '泸州老窖', percentage: 7.8, color: '#EB2F96' }
  ];

  // 招商新能源行业分布数据
  const zhaoshangIndustryData = [
    { name: '新能源汽车', value: 35, color: '#5959EB' },
    { name: '光伏', value: 25, color: '#13C2C2' },
    { name: '风电', value: 20, color: '#1677FF' },
    { name: '其他', value: 20, color: '#EB2F96' }
  ];

  // 易方达消费行业分布数据
  const yifangdaIndustryData = [
    { name: '白酒', value: 40, color: '#5959EB' },
    { name: '食品材料', value: 20, color: '#13C2C2' },
    { name: '互联网', value: 20, color: '#1677FF' },
    { name: '零售', value: 10, color: '#FF7B52' },
    { name: '其他', value: 10, color: '#EB2F96' }
  ];

  return (
    <div className="mb-3 flex flex-col gap-3 rounded-lg border border-gray-200 bg-white p-3">
      {/* 标题行 */}
      <div className="flex items-center gap-2">
        <div className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={selected}
            onChange={e => onSelectChange?.(e.target.checked)}
            className="h-4 w-4 rounded border border-gray-300"
          />
          <span className="text-base font-semibold text-gray-900">持仓穿透分析</span>
        </div>
      </div>

      {/* 两个产品的对比卡片 */}
      <div className="flex flex-col justify-between gap-3">
        {/* 招商新能源卡片 */}
        <div className="flex-1 rounded-lg border border-gray-200 p-3">
          <div className="flex gap-3">
            <HoldingsCard
              title={`${product1Data.产品名称}-前五大持仓`}
              holdings={zhaoshangHoldings}
            />
            <IndustryDistribution
              data={zhaoshangIndustryData}
              PieProps={{ cx: '22%', dataKey: 'value' }}
              legendClass="ml-[-26px]"
            />
          </div>
        </div>

        {/* 易方达消费卡片 */}
        <div className="flex-1 rounded-lg border border-gray-200 p-3">
          <div className="flex gap-3">
            <HoldingsCard
              title={`${product2Data.产品名称}-前五大持仓`}
              holdings={yifangdaHoldings}
            />
            <IndustryDistribution
              data={yifangdaIndustryData}
              PieProps={{ cx: '22%', dataKey: 'value' }}
              legendClass="ml-[-26px]"
            />
          </div>
        </div>
      </div>

      {/* AI总结部分 */}
      <Summary title="AI总结-持仓分析" content={totalData?.持仓分析} isShowSuggestions={false} />
    </div>
  );
};

export default PositionAnalysis;
